import {
    useCallback,
} from 'react'

import DomainObjectForm from 'app/shared-components/DomainObjectForm'
import SkyNetStepperButtons from 'app/shared-components/SkyNetStepper/SkyNetStepperButtons'
import useValidation from 'app/hooks/useValidation/useValidation'

import useLongTermLeaseCreateContext from '../../LongTermLeaseFormContext'
import {
    LongTermLeaseType,
} from '../../../longTermLease.types'
import fields from './customerDetails.fields'

const CustomerDetails = ({
    index,
    disabled,
}: {
    index: number,
    disabled: boolean
}) => {
    const {
        activeStep,
        setActiveStep,
        setIsEdited,
        setValue,
        value,
        initialValue,
    } = useLongTermLeaseCreateContext()

    const {
        isValid,
    } = useValidation({
        fields,
        values: value.firstStep,
    })

    const onChange = (newVal: Partial<LongTermLeaseType>) => {
        setValue({
            ...value,
            firstStep: newVal,
        })
        setIsEdited(true)
    }

    const handleNextAction = useCallback(() => {
        setActiveStep(activeStep + 1)
    }, [
        setActiveStep,
        activeStep,
    ])

    const editAction = useCallback(() => {
        setActiveStep(index)
        setValue({
            ...value,
            secondStep: initialValue.secondStep,
            thirdStep: initialValue.thirdStep,
        })
    }, [
        index,
        initialValue,
        setActiveStep,
        setValue,
        value,
    ])

    return (
        <>
            <DomainObjectForm
                value={value.firstStep}
                onChange={onChange}
                fields={fields}
                disabled={disabled}
                name="OrderByNumberView"
            />
            <SkyNetStepperButtons
                isValid={isValid}
                disabled={disabled}
                nextLabel="Continue"
                nextAction={handleNextAction}
                canEdit={activeStep > index}
                editAction={editAction}
            />
        </>
    )
}

export default CustomerDetails
